import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getProfiles = (query) => axios.get(toQueryString("api/v1/profile-management?", query));

const getProfileData = (query) => axios.get(toQueryString("api/v1/profile-management/profile-data?", query));

const getScenarioData = (query) => axios.get(toQueryString("api/v1/profile-management/scenario-data?", query));

const createProfile = (profile) => axios.post("api/v1/profile-management", profile);

const updateProfile = (id, profile) =>
  axios.put(`api/v1/profile-management/${id}`, profile);

const deleteProfile = (id) => axios.delete(`api/v1/profile-management/${id}`);

const removeBulk = (ids) =>
  axios.delete("api/v1/profile-management/bulk", { data: { ids } });

const reorderProfiles = (orderedIds) =>
  axios.put("api/v1/profile-management/reorder", { orderedIds });

const ApiProfileManagement = {
  getProfiles,
  getProfileData,
  createProfile,
  updateProfile,
  deleteProfile,
  getScenarioData,
  removeBulk,
  reorderProfiles
};

export default ApiProfileManagement;
